<template>
  <Modal
    :isAboveAll="true"
    :hideButtonsContainer="true"
    :headerTitle="'Dealer Mode'"
    :loaderMessage='"Logging In..."'
    :showLoader="eventLoading"
    @closeModal="emitCloseModal()"
  >
    <template #content>
      <p class="text">
        Please enter the Dealer passcode to turn “Dealer Mode” on
      </p>
      <div class="url-container" :class="{ 'mb-4': !error }">
        <input
          type="text"
          v-model="passcode"
          maxlength="20"
          v-on:keyup="keyMonitor"
          ref="inputField"
        />

        <button
          class="btn btn-black"
          :class="{ disabled: error }"
          type="button"
          @click="submit()"
        >
          Confirm
        </button>
      </div>
      <small v-if="error" class="error mb-4 mt-1">Incorrect Password</small>

      <div class="help-text flex align-items-start mb-2">
        <img
          class="info-icon mr-2"
          src="@/assets/icons/ui/information-circle-outline.svg"
          alt="more info icon"
        />
        <p class="text m-0">
          If you need to find your passcode, please check “My Settings” in your
          Gameplan Dealer Panel
        </p>
      </div>
    </template>
  </Modal>
</template>

<script>
import { mapActions, mapState } from "vuex";

import Modal from "@/components/Utils/Modal";

export default {
  name: "DealerLoginModal",
  computed: {
    ...mapState("auth", ["dealerMode"]),
  },
  components: { Modal },

  data() {
    return {
      passcode: "",
      error: false,
      eventLoading: false,
    };
  },

  methods: {
    ...mapActions("auth", ["dealerLogin"]),
    ...mapActions("project", ["setEditMode"]),
    keyMonitor(event) {
      if (this.error) this.error = false;

      if (!this.error) {
        if (event.key == "Enter") {
          this.submit();
        }
      }
    },
    async submit() {
      try {
        if (!this.passcode || this.error) return false;
        this.eventLoading = true;
        await this.dealerLogin(this.passcode);
        this.eventLoading = false;
        if (!this.dealerMode) {
          this.error = true;
        }
      } catch (error) {
        this.$store.dispatch("showToast", {
          txt: error,
          type: "error",
        });
      }
    },
    emitCloseModal() {
      this.$emit("close");
    },
  },

  watch: {
    // Closes modal after successfully logged in,and set the Edit mode
    dealerMode() {
      this.emitCloseModal();
      // this.setEditMode()
      //todo scroll to top?
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.inputField.focus();
    });
  },
};
</script>

<style lang="scss" scoped>
.modal-container {
  width: 25%;
  max-width: 600px;
  margin: auto;
  background: white;
  border-radius: 6px;
  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1.2rem;
    border-bottom: 1px solid $grey-light;
    p {
      text-transform: capitalize;
    }
  }

  .content {
    display: flex;
    flex-flow: column;
    padding: 1.3rem 1.5rem;
    p.text {
      color: $grey-dark;
      margin-bottom: 1rem;
    }

    .url-container {
      display: flex;
      justify-content: space-between;
      border: 1px solid #eaeaea;
      border-radius: 6px;
      overflow: hidden;
      input {
        color: $dark;
        width: 100%;
        background: $grey-lightest;
        padding: 0.5em;
        outline: none;
        border: none;
      }

      button {
        background-color: $dark;
        border-radius: 0 !important;
        color: white;
        padding: 0 0.5rem;
        text-transform: capitalize;
      }
    }

    .error {
      color: $snapsheetColor;
    }

    p.msg {
      padding: 0.5rem 0;
      color: $green;
    }
  }

  @media screen and (max-width: 1024px) {
    width: 40%;
  }
}
</style>
